<template>
  <div class="black-friday-banner pa-5">
    <div>
    <div class="black-friday-banner-title d-block">
      <span class="d-inline mr-1">
        {{ bannerTitle }}
      </span>
      <fire-icon class="d-inline" />
    </div>

    <div
      class="black-friday-banner-description mt-2"
      v-html-safe="bannerText"
    />
    </div>

    <v-btn
      color="button-primary-background-default"
      class="align-self-end black-friday-banner-luck-button"
      height="40"
      elevation="0"
      @click="claimYourSubscriptionNow"
    >
      <span>{{ bannerButtonText }}</span>
    </v-btn>

    <v-btn
      icon
      color="white"
      class="black-friday-banner-luck-button-close-button"
      @click="handleCloseBlackFridayBanner"
    >
      <cross />
    </v-btn>
  </div>
</template>

<script>
import FireIcon from '@/assets/icons/variants/fire.vue'
import Cross from '@/assets/icons/variants/16/cross.vue'

export default {
  name: 'BackToSchoolBanner',

  components: {
    FireIcon,
    Cross,
  },

  computed: {
    bannerTitle () {
      return this.$i18n.locale === 'cn'
        ? this.$t('banners.blackFriday.title', 'en')
        : this.$t('banners.blackFriday.title')
    },

    bannerText () {
      return this.$i18n.locale === 'cn'
        ? this.$t('banners.blackFriday.mainText', 'en')
        : this.$t('banners.blackFriday.mainText')
    },

    bannerButtonText () {
      return this.$i18n.locale === 'cn'
        ? this.$t('banners.blackFriday.claimSubscriptionNow', 'en')
        : this.$t('banners.blackFriday.claimSubscriptionNow')
    },
  },

  methods: {
    claimYourSubscriptionNow () {
      const links = {
        ru: 'https://blackfriday.dolphin-anty.net/',
        ua: 'https://blackfriday.dolphin-anty.net/ua',
        en: 'https://blackfriday.dolphin-anty.net/en',
        pt: 'https://blackfriday.dolphin-anty.net/pt',
        cn: 'https://blackfriday.dolphin-anty.net/en',
        es: 'https://blackfriday.dolphin-anty.net/en'
      }

      const link = links[this.$i18n.locale] || links.en
      window.open(link, '_blank')
    },

    async handleCloseBlackFridayBanner () {
      try {
        this.$store.dispatch('main/hideBanner',  'blackFriday')
        await this.api.post('/profile/quiz', { quizId: 5 })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang='scss'>
.black-friday-banner {
  background-image: url('~@/assets/quiz/blackFridayBox.svg');
  background-size: cover;
  background-position: left;
  position: relative;
  margin-top: 46px;
  border-radius: 12px;
  background-color: #19181A;
  width: 100%;
  display: flex;
}

.black-friday-banner-title {
  color: white;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  white-space: nowrap;

  * {
    vertical-align: text-top;
  }
}

.black-friday-banner-description {
  color: white;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;

  strong {
    font-weight: 600;
  }
}

.black-friday-banner-luck-button {
  position: absolute;
  right: 20px;
  z-index: 10;
  border-radius: 8px;
}

.black-friday-banner-luck-button span {
  letter-spacing: 0;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: none;
  color: #FFFFFF;
}

.black-friday-banner-luck-button-close-button {
  position: absolute;
  padding: 8px;
  right: 8px;
  top: 8px;
  z-index: 10;
}
</style>
